module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor05-f618a4ef51bf143191f15b1543f53004.png";